import { Field, Form, Formik} from "formik";
import React from "react";
import * as Yup from "yup";

const BulkActions = ({selected, actions, onActionSubmitted}) => {
	if (selected.length === 0) {
		return;
	}

	const actionSchema = Yup.object().shape({
		action: Yup.string().required('Required'),
	});

	return (
		<div>
			<Formik
				initialValues={{ action: '' }}
				validationSchema={actionSchema}
				onSubmit={(values, { setSubmitting }) => {
					onActionSubmitted(values).finally(() => setSubmitting(false))
				}}
			>
				{({ isSubmitting, values }) => (
					<Form>
						<div className="d-flex gap-1">
							<div>
								<Field as="select" name="action" className="form-select">
									<option value="" disabled>
										Bulk actions
									</option>
									{actions.map((option) => (
										<option key={option.value}
												value={option.value}>
											{option.label}
										</option>
									))}
								</Field>
							</div>
							<button type="submit" className="btn btn-primary" disabled={isSubmitting || values.action === ''}>
								Apply
							</button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default BulkActions;
